exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-small{font-size:13px;padding:5px 10px;text-transform:none;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cdd3785","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./resources/assets/js/components/Orders/Shipments/Documents/documents.scss
// module id = RFVO
// module chunks = 0